<tt-page *ngIf="!!edit">
    <tt-page-heading *ngIf="!!edit.page_heading" [ttModel]="edit.page_heading"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="delivery_cust_no" [ttModel]="edit.delivery_cust_no" ttReadonly></tt-input>
        <tt-search ttLabel="searchtext_customer" [(ttModel)]="edit.searchtext_customer" [ttSearch]="searchCustomers" (ttOnSelected)="onCustomerSelected($event)" (ttOnClear)="onCustomerSelected()"></tt-search>
        <tt-textarea ttLabel="delivery_address" [ttModel]="edit.delivery_address" ttReadonly></tt-textarea>
        <tt-button-save ttText="deliverycustomer_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="deliveryCustomerKeyno !== '0'" ttText="deliverycustomer_delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
        <tt-button-settings *ngIf="edit.show_setting === '1'"></tt-button-settings>
    </tt-card>
</tt-page>
